









































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitaisStore from '@/components/Suporte/Store/SuporteHospitaisStore'
import EventBus from '@/plugins/EventBus'
import SuporteHospitalSlaStore from '@/components/Suporte/Store/SuporteHospitalSlaStore'
import ModalSuporteHospitalLogo from '@/components/Suporte/components/ModalSuporteHospitalLogo.vue'

@Component({
  components: { ModalSuporteHospitalLogo },
})
export default class ViewSuporteHospitais extends Vue {
  readyState: boolean = false
  loadHospitais: boolean = false
  loadAddHospital: boolean = false
  loadEditHospital: string = ''
  loadEditHisHospital: string = ''
  hospitalSearch: string = ''
  showHospitalSla: boolean = false
  hospitalSlaLoading: string = ''
  hospitalSlaNome: string = ''

  get getSuporteHospitaisStore() {
    return getModule(SuporteHospitaisStore, this.$store)
  }

  set hospitalId(value: string) {
    getModule(SuporteHospitalSlaStore, this.$store).setHospitalId(value)
  }

  get getSuporteHospitalSlaStore() {
    return getModule(SuporteHospitalSlaStore, this.$store)
  }

  get getHospitais() {
    return this.getSuporteHospitaisStore.hospitais
  }

  get loadingAddHospital() {
    return this.loadAddHospital
  }

  set loadingAddHospital(value: boolean) {
    this.loadAddHospital = value
  }

  get loadingEditHospital() {
    return this.loadEditHospital
  }

  set loadingEditHospital(value: string) {
    this.loadEditHospital = value
  }

  get loadingEditHisHospital() {
    return this.loadEditHisHospital
  }

  set loadingEditHisHospital(value: string) {
    this.loadEditHisHospital = value
  }

  get loadingHospitais() {
    return this.loadHospitais
  }

  set loadingHospitais(value: boolean) {
    this.loadHospitais = value
  }

  get getHospitaisTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
      {
        text: 'Ações',
        class: 'table-headers',
        value: '',
        align: 'center',
        sortable: false,
      },
    ]
  }

  async addHospital() {
    this.loadingAddHospital = true
    const request = await this.getSuporteHospitaisStore.getListaDeHospitais()
    if (request.success) {
      this.getSuporteHospitaisStore.setModal({ name: 'hospital', value: true })
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: request.message || 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
        timeout: 5500,
      })
    }
    this.loadingAddHospital = false
  }

  async editarHospital(item: any) {
    this.loadingEditHospital = item.hospitalId
    this.getSuporteHospitaisStore.setHospitalConfigFlag({ ...item })
    this.getSuporteHospitaisStore.setModal({
      name: 'editarHospital',
      value: true,
    })
    this.loadingEditHospital = ''
  }

  async editarHisHospital(item: any) {
    this.loadingEditHisHospital = item.hospitalId
    this.getSuporteHospitaisStore.clearHospitalId()
    await this.getSuporteHospitaisStore.getAllConfigDeFinxParaHisByHospital(
      item.hospitalId,
    )
    this.getSuporteHospitaisStore.setHospitalId(item.hospitalId)
    this.getSuporteHospitaisStore.setModal({
      name: 'deFinxParaHis',
      value: true,
    })
    this.getSuporteHospitaisStore.setMode({ mode: 'CREATE' })
    this.loadingEditHisHospital = ''
  }

  async openHospitalSla(hospital: any) {
    this.hospitalSlaLoading = hospital.hospitalId
    this.hospitalId = hospital.hospitalId
    const response = await this.getSuporteHospitalSlaStore.getHospitalSlaConfig(
      hospital.hospitalId,
    )
    if (response && response.id) {
      await this.getSuporteHospitalSlaStore.getHospitalSla(response.id)
    }
    this.showHospitalSla = true
    this.hospitalSlaNome = hospital.nome
    this.hospitalSlaLoading = ''
  }

  onCloseHospitalSla() {
    this.showHospitalSla = false
    this.getSuporteHospitalSlaStore.clearHospitalId()
    this.getSuporteHospitalSlaStore.clearHospitalSla()
  }

  async openModalLogoHospital(item: { hospitalId: string; nome: string }) {
    this.getSuporteHospitaisStore.setHospitalLogoItem({
      hospitalId: item.hospitalId,
      nome: item.nome,
    })
    await this.getSuporteHospitaisStore.getHospitalLogo(item.hospitalId)
    this.getSuporteHospitaisStore.setModal({ name: 'hospitalLogo', value: true })
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })
    await this.getSuporteHospitaisStore.getHospitalAll()
    this.readyState = true
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }

  beforeDestroy() {
    this.getSuporteHospitaisStore.clearListaDeHospitais()
    this.getSuporteHospitaisStore.clearHospitalConfigFlag()
    this.getSuporteHospitaisStore.clearNovoHospital()
    this.getSuporteHospitaisStore.clearConfigDeFinxParaHis()
    this.getSuporteHospitaisStore.clearDeFinxParaHis()
    this.getSuporteHospitaisStore.clearHospitalId()
    this.getSuporteHospitaisStore.clearHospitalLogoItem()
  }
}
